import pick from 'lodash/pick'
import { Args } from 'src/__generated__/globalTypes'
import {
  useEffect,
  usePersistedState,
  usePersistedUserData,
  useSelector,
} from '.'

type QueryParams = Args & {
  join?: true | undefined
  sponsor?: string | undefined
  isJoiningAffiliate?: true | undefined
  payment?: true | undefined
  client?: string
}

const useQueryParams = (): QueryParams => {
  const { account } = usePersistedUserData()
  const args = useSelector(state => state.route.args)
  const [persistedArgs, setPersistedArgs] = usePersistedState<
    typeof args | undefined
  >('persisted-query-params', undefined)

  useEffect(
    () =>
      persistedArgs &&
      setPersistedArgs({ ...persistedArgs, ...pick(args, ['sponsor']) }),
    [setPersistedArgs, persistedArgs, args],
  )

  return {
    ...args,
    join: 'join' in args ? true : undefined,
    isJoiningAffiliate: 'affiliatejoin' in args ? true : undefined,
    sponsor: account ? undefined : args.sponsor ?? persistedArgs?.sponsor,
    payment: 'payment' in args ? true : undefined,
  }
}

export default useQueryParams
